'use client';

import Link from 'next/link';
import {
  IoMdRibbon,
  IoMdPulse,
  IoMdFitness,
  IoMdHeart,
  IoMdCalendar,
} from 'react-icons/io';
import { Parallax } from 'react-scroll-parallax';
import Image from 'next/image';

export default function Hero() {
  return (
    <section
      id="hero-section"
      className="bg-[url('/images/trattamento-riabilitazione-posturale.webp')] bg-no-repeat bg-cover bg-center">
      <div className="font-alice min-h-[90vh] px-[10%] items-center justify-center flex lg:flex-row flex-col bg-primary-900/90 lg:pt-32 lg:gap-0 gap-3 md:pt-0 pt-32">
        <div className="flex flex-col gap-3 lg:w-[70%] items-center lg:items-start order-first">
          <h2 className="text-xl flex flex-col font-lato font-bold lg:text-start text-center text-ctext-light lg:tracking-wide tracking-normal text-shadow-sm w-[80%]">
            Dott.ssa Angela Formisano
          </h2>
          <h1 className="lg:text-7xl text-6xl font-bold lg:w-[85%] lg:text-start text-center text-ctext-light text-shadow-lg lg:tracking-normal tracking-title">
            Fisioterapia e riabilitazione ad{' '}
            <span className="text-primary-100">Ercolano</span>
          </h1>
          <div className="lg:flex-row flex-col md:gap-6 md:flex hidden mt-8">
            <Link
              className="lg:self-start font-lato text-white font-bold flex items-center gap-3 self-center text-center border border-cta-100 bg-cta-100 hover:bg-cta-100/75 duration-300 text-2xl p-3 rounded-full shadow-lg"
              href="/contatti">
              <IoMdCalendar className="text-3xl md:block hidden" />
              Prenota un appuntamento
            </Link>
            <Link
              className="lg:self-start font-lato font-bold self-center text-center bg-secondary-light hover:bg-secondary-light/75 duration-300 text-primary-900 text-2xl p-3 rounded-full"
              href="/rieducazione-posturale">
              Scopri i trattamenti
            </Link>
          </div>
        </div>
        <div className="bg-primary-100/25 rounded-full overflow-hidden border-2 border-primary-100 shadow-lg">
          <div className="w-[100px] h-[100px] bg-primary-100/75 absolute top-[200px] right-[650px] rounded-full lg:block hidden"></div>
          <div className="w-[200px] h-[200px] bg-primary-100/50 absolute top-[600px] right-[700px] rounded-full lg:block hidden"></div>
          <Image
            src="/images/fisioterapista-angela-formisano.png"
            alt="Hero Image"
            priority
            fetchPriority="high"
            width={433}
            height={433}
          />
        </div>
        <div className="lg:flex-row flex-col md:gap-6 flex md:hidden">
          <Link
            className="lg:self-start text-white tracking-tighter font-semibold flex items-center gap-3 self-center text-center mt-4 border-1 border-cta-100 bg-cta-100 hover:bg-cta-100/75 duration-300 text-xl py-3 px-6 rounded-full shadow-lg"
            href="/contatti">
            <IoMdCalendar className="text-3xl md:block hidden" />
            Prenota un appuntamento
          </Link>
          <Link
            className="lg:self-start font-semibold tracking-tighter self-center text-center mt-4 bg-secondary-light hover:bg-secondary-light/75 duration-300 text-primary-900 text-xl py-3 px-6 rounded-full shadow-lg"
            href="/rieducazione-posturale">
            Scopri i trattamenti
          </Link>
        </div>
      </div>
      <div className="bg-primary-900/90 flex flex-col">
        <Parallax className="flex flex-col" speed={-5}>
          <div
            className="z-20 lg:w-[80%] w-[90%] bg-secondary-light flex lg:flex-row flex-col self-center relative top-30 rounded-xl lg:py-12 px-6 shadow-2xl"
            id="div-container-list">
            <div className="flex flex-col lg:gap-6 gap-2 text-center lg:border-r-1 lg:border-b-0 border-b-1 border-secondary-100 lg:px-6 lg:py-0 py-6 min-w-[25%]">
              <div className="rounded-full p-3 bg-primary-100/10 w-20 h-20 flex items-center self-center">
                <IoMdRibbon className="text-6xl self-center text-primary-300" />
              </div>
              <h3 className="text-2xl font-bold text-ctext">
                Esperienza e Formazione
              </h3>
              <p className="font-lato text-lg leading-text text-ctext/75">
                Anni di esperienza e continuo impegno nella formazione
                professionale per offrire il miglior trattamento possibile
              </p>
            </div>
            <div className="flex flex-col lg:gap-6 gap-2 text-center lg:border-r-1 lg:border-b-0 border-b-1 border-secondary-100 lg:px-6 lg:py-0 py-6 min-w-[25%]">
              <div className="rounded-full p-3 bg-primary-100/10 w-20 h-20 flex items-center self-center">
                <IoMdHeart className="text-6xl self-center text-primary-300" />
              </div>
              <h3 className="text-2xl font-bold text-ctext">
                Trattamenti Personalizzati
              </h3>
              <p className="font-lato text-lg leading-text text-ctext/75">
                Percorsi terapeutici su misura per ogni paziente
              </p>
            </div>
            <div className="flex flex-col lg:gap-6 gap-2 text-center lg:border-r-1 lg:border-b-0 border-b-1 border-secondary-100 lg:px-6 lg:py-0 py-6 min-w-[25%]">
              <div className="rounded-full p-3 bg-primary-100/10 w-20 h-20 flex items-center self-center">
                <IoMdFitness className="text-6xl self-center text-primary-300" />
              </div>
              <h3 className="text-2xl font-bold text-ctext">
                Strumentazione moderne
              </h3>
              <p className="font-lato text-lg leading-text text-ctext/75">
                Utilizzo tecnologie ed attrezzature all'avanguardia per
                garantire la miglior qualità ed efficacia dei trattamenti
              </p>
            </div>
            <div className="flex flex-col lg:gap-6 gap-2 text-center min-w-[25%] lg:px-6 lg:py-0 py-6">
              <div className="rounded-full p-3 bg-primary-100/10 w-20 h-20 flex items-center self-center">
                <IoMdPulse className="text-6xl self-center text-primary-300" />
              </div>
              <h3 className="text-2xl font-bold text-ctext">
                Professionalità e Dedizione
              </h3>
              <p className="font-lato text-lg leading-text text-ctext/75">
                Garantisco la massima professionalità e dedizione alla
                risoluzione del problema in ogni fase del trattamento
              </p>
            </div>
          </div>
        </Parallax>
      </div>
    </section>
  );
}
